import setWindowSettings from '@/assets/ts/setting'

setWindowSettings()

/**
 * Retrieves the base URL of the site and ensures it does not end with a slash.
 * @returns {string} The base URL without a trailing slash
 * @example
 * // en site: https://test-hk.buynship.com/en
 * // default site: https://test-tw.buynship.com/
 */
export function getSiteBaseUrl(): string {
	const siteBaseURL = removeLastSlash(window.BUYANDSHIP.settings.base_url)
	return siteBaseURL
}

/**
 * Retrieves the base path for member-related pages, removing the '/en' prefix if present.
 * @returns {string} The base member path
 * @example
 * // en site: /account/v2020
 * // default site: /account/v2020
 */
export function getSiteBaseMemberPath(): string {
	return window.BUYANDSHIP.settings.member_base_path.replace(/^\/en/, '')
}

/**
 * Constructs the full URL for the MCR (Member Center Redesign) root.
 * @returns {string} The complete MCR root URL
 * @example
 * // default site: https://test-tw.buynship.com/account/v2020
 * // en site: https://test-tw.buynship.com/en/account/v2020
 */
export function getMcrRootUrl(): string {
	return `${getSiteBaseUrl()}${getSiteBaseMemberPath()}`
}

/**
 * Removes the trailing slash from a given URL or path.
 * @param link - The URL or path string from which the trailing slash should be removed.
 * @returns The input string without the trailing slash.
 */
export function removeLastSlash(link: string) {
	return link.replace(/\/$/, '')
}

export function isHomePage() {
	const currentPath = window.location.pathname
	return currentPath === '/' || currentPath === '/en/'
}
